export default __webpack_public_path__ + "static/media/Group 3398.bc2ada45.png";